import classNames from 'classnames';

import { CHAT_TYPE } from '../../../../const';
import ImageLoader from '../../ImageLoader';
import MarketPlaceActionButton from '../../MarketplaceActionButton';
import styles from './styles.module.scss';

const CatalogCard = (props) => {
    const {
        img = '',
        title = '',
        text = '',
        classes = [],
        advisorAlias = '',
        advisorId = '',
        isAllowMulti = false,
        isActivities = false
    } = props;

    return (
        <div className={classNames(styles.card, ...classes)}>
            <div className={styles.image}>
                <ImageLoader src={img} alt={title} loaderSize={64} />
            </div>
            <div className={styles.column}>
                <h2 className={styles.title}>{title}</h2>
                <div className={styles.text}>{text}</div>
                <MarketPlaceActionButton
                    isActivities={isActivities}
                    advisorId={advisorId}
                    advisorAlias={advisorAlias}
                    classes={[styles.btn, styles.catalogBtn, !isAllowMulti ? styles.inMultiCard : null]}
                />
                {isAllowMulti && (
                    <MarketPlaceActionButton
                        advisorId={advisorId}
                        advisorAlias={advisorAlias}
                        classes={[styles.btn]}
                        chatType={CHAT_TYPE.MULTIPLY}
                        isTransparent={true}
                    />
                )}
            </div>
        </div>
    );
};

export default CatalogCard;
